<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [WishlistButton],

  props: {
    isSgphx: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: String,
      default: '',
    },
    buttonSize: {
      type: String,
      default: '',
    },
  },

  computed: {
    iconSizeClass() {
      if (!this.iconSize) {
        return '';
      }

      if (this.isSgphx) {
        return `sgphx-icon--${this.iconSize}`;
      }
      return `ico--${this.iconSize}`;
    },

    buttonSizeClass() {
      if (!this.buttonSize) return '';
      return `button--${this.buttonSize}`;
    },

    buttonClasses() {
      if (this.isSgphx) {
        return ['sgphx-btn sgphx-btn--icon-only sgphx-btn--icon'];
      }
      return ['sgphx', 'button', 'button--icon', this.buttonSizeClass];
    },

    iconClasses() {
      return [this.iconSizeClass];
    },
  },
};
</script>

<template>
  <button
    :class="buttonClasses"
    :aria-label="ariaLabel"
    :data-tracking="trackingDatalayer"
    data-cy="wishlist-button"
    @click.prevent="toggleProduct({ reference, showBanner })"
  >
    <phx-icon :key="icon" :icon="icon" :class="iconClasses" />
  </button>
</template>
